import { render, staticRenderFns } from "./PersonSelect.vue?vue&type=template&id=ee0975ca&scoped=true&"
import script from "./PersonSelect.vue?vue&type=script&lang=js&"
export * from "./PersonSelect.vue?vue&type=script&lang=js&"
import style0 from "./PersonSelect.vue?vue&type=style&index=0&id=ee0975ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0975ca",
  null
  
)

export default component.exports